var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "searchOptions" } },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { inline: true, model: _vm.form, "label-width": "70px" },
        },
        [
          _c(
            "el-row",
            [
              _vm.curComponent == "waybillDetailPage"
                ? _c("el-form-item", { attrs: { prop: "printStatus" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "y-fc-4C84FF y-pr-15 y-c-p",
                        on: { click: _vm.goback },
                      },
                      [_vm._v("<< 返回")]
                    ),
                  ])
                : _vm._e(),
              _vm.curComponent !== "waybillDetailPage"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "queryDateType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "y-w-136",
                            attrs: {
                              "popper-append-to-body": false,
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.form.queryDateType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "queryDateType", $$v)
                              },
                              expression: "form.queryDateType",
                            },
                          },
                          [
                            _vm.curComponent == "PACKAGE_PRINT"
                              ? _c("el-option", {
                                  attrs: { label: "建包时间", value: "0" },
                                })
                              : _vm._e(),
                            _vm.curComponent == "BULK_PRINT"
                              ? _c("el-option", {
                                  attrs: { label: "揽收时间", value: "1" },
                                })
                              : _vm._e(),
                            _vm.curComponent == "PACKUP_PACKAGE"
                              ? _c("el-option", {
                                  attrs: { label: "上车时间", value: "1" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "createTime" } },
                      [
                        _c("yto-date-picker", {
                          attrs: {
                            maxRangeVal: 7,
                            customDaysName: `JBDY_${this.curComponent}_customrange`,
                            curShortcutName: _vm.curShortcutName,
                            clearable: false,
                            editable: false,
                            "picker-options": _vm.pickerOptions1,
                            type: "datetimerange",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "default-time": ["00:00:00", "23:59:59"],
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy.MM.dd HH:mm",
                          },
                          model: {
                            value: _vm.form.createTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "createTime", $$v)
                            },
                            expression: "form.createTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "mallCode" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "y-w-136",
                            attrs: {
                              "popper-append-to-body": false,
                              placeholder: "请选择店铺",
                            },
                            model: {
                              value: _vm.form.mallCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mallCode", $$v)
                              },
                              expression: "form.mallCode",
                            },
                          },
                          _vm._l(_vm.storList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.shopName,
                                value: item.shopCode + "",
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.curComponent !== "PACKUP_PACKAGE"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "pickupStatus" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "y-w-136",
                                attrs: {
                                  "popper-append-to-body": false,
                                  placeholder: "上车状态",
                                  clearable: true,
                                },
                                model: {
                                  value: _vm.form.pickStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "pickStatus", $$v)
                                  },
                                  expression: "form.pickStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "待上车", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "上车失败", value: "-1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.curComponent !== "PACKUP_PACKAGE"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "printStatus" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "y-w-136",
                                attrs: {
                                  "popper-append-to-body": false,
                                  placeholder: "打印状态",
                                  clearable: true,
                                },
                                model: {
                                  value: _vm.form.printStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "printStatus", $$v)
                                  },
                                  expression: "form.printStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "待打印", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "已打印", value: "1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.curComponent == "PACKAGE_PRINT"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "buildPackageType" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "y-w-136",
                                attrs: {
                                  "popper-append-to-body": false,
                                  placeholder: "建包类型",
                                  clearable: true,
                                },
                                model: {
                                  value: _vm.form.buildPackageType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "buildPackageType", $$v)
                                  },
                                  expression: "form.buildPackageType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "自动建包", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "手动建包", value: "1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.curComponent == "PACKUP_PACKAGE"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "packageDataType" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "y-w-136",
                                attrs: {
                                  "popper-append-to-body": false,
                                  placeholder: "上车类型",
                                  clearable: true,
                                },
                                model: {
                                  value: _vm.form.packageDataType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "packageDataType", $$v)
                                  },
                                  expression: "form.packageDataType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "建包上车", value: "1" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "散件上车", value: "0" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.curComponent == "PACKAGE_PRINT"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "buildPageName" } },
                          [
                            _c("el-input", {
                              staticClass: "y-w-136",
                              attrs: {
                                placeholder: "建包名称",
                                clearable: true,
                              },
                              model: {
                                value: _vm.form.buildPageName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "buildPageName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.buildPageName",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.curComponent == "PACKAGE_PRINT"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "packageWaybillNo" } },
                          [
                            _c("el-input", {
                              staticClass: "y-w-136",
                              attrs: { placeholder: "包签号", clearable: true },
                              model: {
                                value: _vm.form.packageWaybillNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "packageWaybillNo",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.packageWaybillNo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "shortAddress" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-136",
                          attrs: { placeholder: "一段码", clearable: true },
                          model: {
                            value: _vm.form.shortAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "shortAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.shortAddress",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.curComponent == "BULK_PRINT"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "orderNo" } },
                          [
                            _c("el-input", {
                              staticClass: "y-w-180",
                              attrs: { placeholder: "订单号", clearable: true },
                              model: {
                                value: _vm.form.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "orderNo",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.orderNo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "mailNo" } },
                [
                  _c("el-input", {
                    staticClass: "y-w-180",
                    attrs: { placeholder: "运单号", clearable: true },
                    model: {
                      value: _vm.form.mailNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "mailNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.mailNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.searchFormData },
                    },
                    [_vm._v("查询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "normal-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-refresh-left y-fc-4C84FF",
                      }),
                      _vm._v("重置"),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticStyle: { clear: "both" } }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }